import { BG_SCHEMA, TITLE_SCHEMA, SUBTITLE_SCHEMA, TEXT_SCHEMA, BUTTON_SCHEMA } from '../common/content'
import { commonBeforeParseMethod, commonGetIdMethod } from '../helpers'

export const CRM_FORM_OPTIONS = () => ([
  {id: 1, label: 'Nome', key: 'name'},
  {id: 2, label: 'E-mail', key: 'email'},
  {id: 3, label: 'Documento', key: 'doc'},
  {id: 4, label: 'Data de Nascimento', key: 'birthdate'},
  {id: 5, label: 'Telefone', key: 'phone'},
  {id: 6, label: 'Cidade', key: 'city'},
])

export const CRM_SELECTED_LISTS_INFO = ({codigo, nome, token} = {codigo: '', nome: '', token: ''}) => ({
  _codigo: codigo, // example: 0;321 -> where 0 is groupId and 321 code of List
  nome: nome,
  token: token
})

export const CRM_SCHEMA = config => {
  const {id, idLayout, pageId} = commonGetIdMethod(config)

  return {
    type: 'crm',
    id: id,
    idLayout: idLayout,
    pageId: pageId,
    name: '',
    title: TITLE_SCHEMA('Cadastro no CRM'),
    subtitle: SUBTITLE_SCHEMA(),
    text: TEXT_SCHEMA(),
    bg: BG_SCHEMA(),
    buttons: [BUTTON_SCHEMA()],
    'text-position': 'center',
    'text-color': '#202020',
    'layer-color': '#FFFFFF',
    formOptions: [1, 2, 3, 4, 5, 6],
    listMsg: 'Listas',
    lists: [''],
    /**
      Guarda o informações das listas selecionadas, pois não é possivel realizar a requisição no modo visualização
      pois não existee token de acesso, e a requisição precisa do token.
     */
    selectedListsInfo: [CRM_SELECTED_LISTS_INFO()]
  }
}

export const beforeParseCRM = target => {
  // sessão nova, não existia anteriormente então nao precisa de métodos aqui.
}

export const CRM_SECTION = config => ({
  schema: CRM_SCHEMA(config),
  beforeParse: beforeParseCRM
})
